import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Layout from './components/layout';
import { CartProvider } from './context/CartContext';
import { ToastProvider } from './admincomponents/AdminToast';
import { ToastProvider as UserToastProvider } from './components/userToast';
import CartDrawer from './components/CartDrawer';
import reportWebVitals from './reportWebVitals';
import App from './App';
import Shop from './shop';
import ProductPage from './product';
import Contact from './contact';
import Faq from './faq';

import AdminRegister from './adminpages/register';
import AdminLogin from './adminpages/login';
import AdminLayout from './admincomponents/AdminLayout';
import AdminDashboard from './adminpages/App';
import Orders from './adminpages/orders';
import Products from './adminpages/products';
import Brands from './adminpages/brands';
import Categories from './adminpages/category';
import Customers from './adminpages/customers';
import Settings from './adminpages/settings';
import CustomPages from './adminpages/custom-page';
import LegacyCustomPages from './adminpages/LegacyCustomPages';
import LegacyCustomPageEditor from './adminpages/LegacyCustomPageEditor';
import LegacyCustomPageView from './components/LegacyCustomPageView';
import RequireAdminAuth from './admincomponents/Middleware';
import Login from './login';
import Register from './register';
import ForgotPassword from './forgetpassword'; // adjust path if different
import AgeGate from './components/age';
import Showpages from './adminpages/ShowPage';
import NotFound from './components/pagenotfound';
import ScrollToTop from './components/scrollto';
import ResetPassword from './resetpassword';
import AdminForgotPassword from './adminpages/forgot';
import AdminResetPassword from './adminpages/reset';
import Adminreviews from './adminpages/reviews';
import Checkout from './checkout';
import OrderSuccess from './ordersucess';


const publicRoutes = [
  { link: '/', component: <App /> }, 
  { link: '/shop', component: <Shop /> },
  { link: '/product/:id', component: <ProductPage /> },
  { link: '/contact', component: <Contact /> },
  { link: '/faq', component: <Faq /> },
];


const noLayoutPublicRoutes = [
  { link: '/checkout', component: <Checkout /> },
  { link: '/order-success', component: <OrderSuccess /> },
];


const userAuthRoutes = [
      
  { link: '/login', component: <Login /> },
  { link: '/register', component: <Register /> },
  { link: '/forgot-password', component: <ForgotPassword /> },
  { link: '/reset-password', component: <ResetPassword /> },
];


const adminAuthRoutes = [
  { link: '/admin/login', component: <AdminLogin /> },
  { link: '/admin/register', component: <AdminRegister /> },
  { link: '/admin/forgot-password', component: <AdminForgotPassword /> },
  { link: '/admin/reset-password', component: <AdminResetPassword /> },
];


const adminRoutes = [
  { link: '/admin', component: <AdminDashboard /> },
  { link: '/admin/orders', component: <Orders /> },
  { link: '/admin/products', component: <Products /> },
  { link: '/admin/brands', component: <Brands /> },
  { link: '/admin/categories', component: <Categories /> },
  { link: '/admin/customers', component: <Customers /> },
  { link: '/admin/pages', component: <Showpages /> },
  {link:'/admin/pagebuilder',component:<Navigate to="/admin/editppage/home" replace />},
  {link:'/admin/editppage/:slug',component:<CustomPages/>},
  {link:'/admin/custom-pages',component:<LegacyCustomPages/>},
  {link:'/admin/custom-page-builder',component:<LegacyCustomPageEditor/>},
  {link:'/admin/custom-page-builder/:id',component:<LegacyCustomPageEditor/>},

   {link:'/admin/reviews',component:<Adminreviews/>},
    
];

const withAdminToast = (element) => <ToastProvider>{element}</ToastProvider>;

const withUserToast = (element) => <UserToastProvider>{element}</UserToastProvider>;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <BrowserRouter>
  <ScrollToTop />
  <CartProvider>
    <CartDrawer />
    <Routes>
      {publicRoutes.map((route, i) => (
        <Route
          key={`public-${i}`}
          path={route.link}
          element={<Layout><AgeGate>{withUserToast(route.component)}</AgeGate></Layout>}
        />
      ))}

      {noLayoutPublicRoutes.map((route, i) => (
        <Route
          key={`no-layout-public-${i}`}
          path={route.link}
          element={<AgeGate>{withUserToast(route.component)}</AgeGate>}
        />
      ))}

      {userAuthRoutes.map((route, i) => (
        <Route
          key={`user-auth-${i}`}
          path={route.link}
          element={<AgeGate>{withUserToast(route.component)}</AgeGate>}
        />
      ))}

      {adminAuthRoutes.map((route, i) => (
        <Route
          key={`admin-auth-${i}`}
          path={route.link}
          element={withAdminToast(route.component)}
        />
      ))}

      {adminRoutes.map((route, i) => (
        <Route
          key={`admin-${i}`}
          path={route.link}
          element={
            <RequireAdminAuth>
              {withAdminToast(<AdminLayout>{route.component}</AdminLayout>)}
            </RequireAdminAuth>
          }
        />
      ))}

      <Route
        path="/404"
        element={<Layout>{withUserToast(<NotFound />)}</Layout>}
      />

      <Route
        path="/:slug"
        element={<Layout><AgeGate>{withUserToast(<LegacyCustomPageView />)}</AgeGate></Layout>}
      />

      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  </CartProvider>
</BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();